import { Injectable } from '@angular/core';

export const getLocalStorage = (): Storage => {
  return localStorage;
};

@Injectable({ providedIn: 'root' })
export class LocalStorageRefService {
  get localStorage(): Storage {
    return getLocalStorage();
  }
}
